import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function CTA() {
  return (
    <section className="relative py-16 md:py-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20cozy%20reading%20corner%20with%20soft%20blanket%20and%20books%2C%20gentle%20warm%20lighting%20from%20table%20lamp%2C%20autumn%20atmosphere%2C%20cream%20and%20amber%20tones%2C%20comfortable%20home%20interior%2C%20relaxing%20ambiance%2C%20shallow%20depth%20of%20field&width=1600&height=600&seq=cta-bg-01&orientation=landscape"
          alt="阅读背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-secondary-900/80 to-secondary-900/40"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50">收藏本站不迷路</h2>
        <p className="mt-3 text-base text-background-200 max-w-xl mx-auto">
          每日更新最新章节，为您带来最新最热的丝袜小说，精彩不容错过
        </p>
        <div className="flex items-center justify-center gap-4 mt-6 flex-wrap">
          <Link
            to="/category/qingchun-xiaoyuan"
            className="px-5 py-2.5 bg-accent-500 text-background-50 rounded-full text-sm font-medium hover:bg-accent-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            热门分类
          </Link>
          <Link
            to="/about"
            className="px-5 py-2.5 bg-background-50/15 text-background-50 rounded-full text-sm font-medium border border-background-50/25 hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            关于我们
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-10 max-w-2xl mx-auto">
          {[
            { label: '精品原创', value: '500+' },
            { label: '热门分类', value: '6' },
            { label: '日更新量', value: '12+' },
            { label: '累计阅读', value: '148万+' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-accent-300">{stat.value}</div>
              <div className="text-xs text-background-300 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}